<template>
  <GeneralStudents />
</template>

<script>
import GeneralStudents from "../../components/GeneralStudents/General.vue";
export default {
  components: {
    GeneralStudents,
  },
};
</script>